import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, Spinner, Modal, Alert, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Switch from 'react-switch';
import AppSpinner from '../AppSpinner/AppSpinner';
import apiUrl from '../../utils/apiUrl';
import formatMoney from '../../utils/formatMoney';
import moment from 'moment';
import { connect } from 'react-redux';

const select = state => {
  return {
    token: state.auth.token
  };
};

class ConnectedFoundationPaymentDetailComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      submitting: false,
      show: false,
      paymentNotFound: false,
      formValidated: false,
      payed: false,
      datePayed: '',
      voucherPhoto: undefined,
      voucherPhotoName: '',
      totalAmount: 0,
      totalWithdrawn: 0,
      data: {}
    };

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClose() {
    this.setState({show: false});
  }

  handleSwitchChange(checked) {
    this.setState({payed: checked});
  }

  triggerInputFile(input) {
    this[input].click();
  }

  handleFileChange(event) {
    if(event.target.files[0]) {
      const name = event.target.name + 'Name';
      this.setState({[event.target.name]: event.target.files, [name]: event.target.files[0].name});
    }
  }

  handleDateChange(event) {
    this.setState({datePayed: event.target.value});
  }

  async componentDidMount() {

    const {id, token} = this.props;

    const paymentInfoResp = await fetch(`${apiUrl}/admin/foundations/payment/${id}?token=${token}`);
    const paymentData = await paymentInfoResp.json();
    
    if (paymentData.success) {
      const { data, amount, totalWithdrawn } = paymentData;
      this.setState({
        data,
        totalAmount: amount,
        totalWithdrawn,
        voucherPhotoName: data.voucherPhoto ? `${data.voucherPhoto.split('com/')[1]}.png` : '',
        datePayed: data.datePayed ? data.datePayed.split('T')[0] : '',
        payed: data.status === 'RECEIVED'
      });

    } else {
      this.setState({ paymentNotFound: true });
    }

    this.setState({ isLoading: false });

  }

  readFile(file) {
    const reader = new FileReader();
    reader.addEventListener('load', undefined);

    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append('file', file);

    return formData;
  }

  async uploadFile(fileInput) {

    let fileUrl;

    if (fileInput) {

      const formData = this.readFile(fileInput[0]);

      const uploadFile = await fetch(`${apiUrl}/files/file-upload`, {
        method: 'POST',
        body: formData
      });

      const fileJson = await uploadFile.json();
      fileUrl = fileJson.fileUrl;
    }

    return fileUrl;
  }

  async handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ formValidated: true, submitting: true });
    const form = event.currentTarget;

    const {
      voucherPhotoName,
      payed,
      voucherPhoto,
      datePayed
    } = this.state;
    const { token, id } = this.props;

    if (form.checkValidity() && voucherPhotoName) {

      let fileUrl;
      if (voucherPhoto) fileUrl = await this.uploadFile(voucherPhoto);

      const updateFoundationPayment = await fetch(`${apiUrl}/admin/foundation/payment/update?token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id,
          status: payed ? 'RECEIVED': 'REQUESTED',
          datePayed: new Date(datePayed).toUTCString(),
          voucherPhoto: fileUrl || ''
        })
      });

      const updateFoundationPaymentJson = await updateFoundationPayment.json();
      if (updateFoundationPaymentJson.success) this.setState({ show: true });
    }

    this.setState({ submitting: false });
  }

  render() {

    const {
      isLoading,
      data,
      show,
      paymentNotFound,
      // totalAmount,
      voucherPhoto,
      voucherPhotoName,
      formValidated,
      datePayed,
      // totalWithdrawn,
      payed,
      submitting
    } = this.state;

    if (isLoading) return (<AppSpinner />);
    if (paymentNotFound) return (<h1 className="not-found-error">El desembolso especificado no existe.</h1>);

    const {
      amount,
      // transactionCost,
      // cuatroPorMil,
      status,
      type,
      dateRequested,
      foundationName,
      programName,
      foundationId,
      bankName,
      bankAccountType,
      bankAccountNumber,
      bankAccountValidation
    } = data;

    // const costoTransferencia = transactionCost;
    const displayedVoucherPhotoName = !voucherPhotoName ? '' :
    (voucherPhotoName.length > 25 ? `${voucherPhotoName.substring(0, 25)}...` : voucherPhotoName);

    const mainDisbursement = !data.linkedDisbursementId;
    const hasLinkedDisbursements = data.items && data.items.length > 0;

    return (
      <div className="detail-info-component foundation-payment-detail-component">
        <Container>
          <Row>
            <Col xs={12}>
              <Link to="/fundaciones/desembolsos">
                <Button variant="secondary" style={{ marginBottom: '15px' }}>
                  Atrás
                </Button>
              </Link>
            </Col>

            {
              !bankAccountValidation ?
              <Col xs={12}>
                <h3 className="not-found-error">
                  La fundación que solicitó el desembolso tiene información bancaria que aún no se ha validado.
                  Por favor valida esta información antes de realizar el desembolso.
                  Puedes ver la información de la fundación <Link to={`/fundaciones/${foundationId}`}>aquí</Link>.
                </h3>
              </Col> : 
            
              <Form onSubmit={this.handleSubmit} validated={formValidated} noValidate>
                <Col xs={12}>
                  <h3 style={{textAlign: 'center'}}>Información</h3>

                  {
                    // status === 'REQUESTED' &&
                    // <h5>
                    //   Disponible:
                    //   ${formatMoney((totalAmount - cuatroPorMil - costoTransferencia - totalWithdrawn).toFixed(0))} COP
                    // </h5>
                  }

                  <Form.Row>
                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Fundación:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={foundationName}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Programa:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={programName}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      {/* <Form.Label><strong>Valor:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={`$${formatMoney(amount)}`}
                        disabled
                      /> */}
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Estado:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={status}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Tipo:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={type}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Fecha de solicitud:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={moment(dateRequested).format('YYYY-MM-DD')}
                        disabled
                      />
                    </Form.Group>

                  </Form.Row>

                </Col>

                <Col xs={12}>
                  <hr/>
                  <h3>Información bancaria</h3>

                  <Form.Row>
                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Banco:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={bankName}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Tipo de cuenta:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={bankAccountType}
                        disabled
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={4}>
                      <Form.Label><strong>Número de cuenta:</strong></Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue={bankAccountNumber}
                        disabled
                      />
                    </Form.Group>

                  </Form.Row>

                </Col>

                <Col xs={12}>

                  <hr/>
                  {
                    !mainDisbursement &&
                    <Alert variant="warning">
                      Este desembolso se encuentra vinculado a <a href={`/fundaciones/desembolsos/${data.linkedDisbursementId}`}>este desembolso</a>.
                      En este último podrás editar el estado, fecha y comprobante de estos desembolsos.
                    </Alert>
                  }
                  <Alert variant="info">
                    
                    <h3>Desembolso</h3>
                    <hr />

                    <h5>Resumen</h5>
                    <Table bordered variant="success">
                      <thead>
                        <tr>
                          <th>Referencia</th>
                          <th>Descripción</th>
                          <th>Valor desembolso</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><strong>Este desembolso</strong></td>
                          <td>{programName ? `Desembolso programa: ${programName}` : 'Desembolso organización'}</td>
                          <td>{formatMoney(amount)}</td>
                        </tr>
                        {
                          data.items && data.items.map((item, index) =>
                            <tr key={index}>
                              {
                                index === 0 && <td rowSpan={data.items.length}><strong>Desembolsos vinculados</strong></td>
                              }
                              <td>
                                {item.programId ? `Desembolso programa: ${item.programId}. ` : 'Desembolso a organización. '}
                                <a href={`/fundaciones/desembolsos/${item._id}`}>(Ver desembolso)</a>
                              </td>
                              <td>{formatMoney(item.amount)}</td>
                            </tr>
                          )
                        }
                        <tr>
                          <td></td>
                          <td><strong>TOTAL</strong></td>
                          <td>
                            <strong>
                              {formatMoney(amount + (data.items ? data.items.reduce((prev, item) => prev + item.amount, 0) : 0))}{hasLinkedDisbursements && '*'}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                    
                    {
                      hasLinkedDisbursements &&
                      '*Este es el valor total consolidado de todos los desembolsos vinculados teniendo en cuenta una única transferencia interbancaria.'
                    }
                    <hr />

                    {
                      hasLinkedDisbursements &&
                      <Alert variant="warning">
                        Ten en cuenta que los cambios que hagas sobre este desembolso (estado, fecha de desembolso, comprobante) se aplicarán a todos los desembolsos vinculados.
                      </Alert>
                    }

                    <Form.Row>
                      <Col md={12}>
                        <div className="switch-input">
                          <span>Desembolso realizado</span>
                          <Switch
                            onChange={this.handleSwitchChange}
                            checked={payed}
                            disabled={!mainDisbursement}
                          />
                        </div>
                      </Col>

                      <Form.Group as={Col} md={4}>
                        <Form.Label><strong>Fecha de desembolso:</strong></Form.Label>
                        <Form.Control
                          type="date"
                          value={datePayed}
                          onChange={this.handleDateChange}
                          disabled={!mainDisbursement}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Ingresa un valor válido.
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group as={Col} md={8}>
                        <Form.Label><strong>Comprobante de pago (imagen):</strong></Form.Label>
                        <Form.Control
                          type="file"
                          ref={fileInput => this.voucherPhoto = fileInput}
                          name='voucherPhoto'
                          files={voucherPhoto}
                          onChange={this.handleFileChange}
                          accept='image/*'
                          hidden
                        />
                        <div className="form-custom-file-input">
                          <Button onClick={() => this.triggerInputFile('voucherPhoto')} disabled={!mainDisbursement}>
                            Selecciona un archivo
                          </Button>
                          <span style={{marginLeft: '5px'}}>
                            {
                              displayedVoucherPhotoName ? !voucherPhoto ?
                              <a href={data.voucherPhoto} target="_blank" rel="noopener noreferrer">{displayedVoucherPhotoName}</a> :
                              voucherPhotoName
                              : 'No hay archivos seleccionados'
                            }
                          </span>
                          {
                            formValidated && !voucherPhotoName && 
                            <div className="invalid-input-value">
                              Sube un documento válido.
                            </div>
                          }
                        </div>
                      </Form.Group>

                    </Form.Row>
                  </Alert>

                </Col>

                {
                  mainDisbursement &&
                  <div className="form-buttons">
                    <Link to="/fundaciones/desembolsos">
                      <Button variant="secondary">
                        Atrás
                      </Button>
                    </Link>

                    <Button type="submit" className="nibi-btn">
                      {
                        submitting ? <Spinner animation="border" variant="warning" size="sm" /> : 'Guardar cambios'
                      }
                    </Button>
                  </div>
                }

              </Form>
            }
          </Row>
        </Container>
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cambios guardados</Modal.Title>
          </Modal.Header>
          <Modal.Body>Se han guardado los cambios</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={this.handleClose}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
 
}

const FoundationPaymentDetailComponent = connect(select)(ConnectedFoundationPaymentDetailComponent);

export default FoundationPaymentDetailComponent;
